export default [
    {
        path: '/users',
        name: 'PageUsersList',
        meta: { title: 'users.listTitle', roles: ['ADMIN', 'TEAM_LEADER'] },
        component: () => import('@/pages/users'),
    },
    {
        path: '/users/create',
        name: 'PageUsersCreate',
        meta: { title: 'users.createFormTitle', roles: ['ADMIN', 'TEAM_LEADER'] },
        component: () => import('@/pages/users/create'),
    },
    {
        path: '/users/:id/edit',
        name: 'PageUsersEdit',
        meta: { title: 'users.editFormTitle', roles: ['ADMIN', 'TEAM_LEADER'] },
        component: () => import('@/pages/users/id/edit'),
    },
]